/**
 * @fileoverview Agent definition for inspiration-ideas-generator-v2.
 *
 * Generates three simple story concepts (title + summary) inspired by existing stories.
 * Part of the two-step ideation flow: this agent generates ideas, then story-planner expands the selected one.
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'inspiration-ideas-generator-v2',
  kind: 'primitive',
  name: 'Inspiration Ideas Generator',
  description: 'Generates three simple story concepts (title + summary) inspired by existing stories.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.story.plot',
    usedBy: ['use-inspiration-ideas-generator-v2.ts', 'plot-ideation-card.tsx'],
    relatedAgents: ['plot-ideas-generator-v2', 'sequel-ideas-generator-v2'],
  },
};
